module.exports = __webpack_public_path__ + "img/pic.6a553a7f.jpg";